module.exports = __webpack_public_path__ + "static/media/marion-michele-727293-unsplash.953824b0.jpg";